import request from "../utils/request";

export const GOOGLE_DRIVE_API = {
    /**
     * Google Drive dosyalarını listeler
     * @param {string} channelId - Kanal ID
     * @param {string} folderId - Klasör ID (opsiyonel)
     * @param {string} pageToken - Sayfalama token (opsiyonel)
     * @param {string} driveId - Shared Drive ID (opsiyonel)
     */
    listFiles: (channelId, folderId, pageToken, driveId) => {
        const params = {};
        if (folderId) params.folderId = folderId;
        if (pageToken) params.pageToken = pageToken;
        if (driveId) params.driveId = driveId;
        return request.get(`/google-drive/channels/${channelId}/files`, { params });
    },

    /**
     * Shared Drive'ları listeler
     * @param {string} channelId - Kanal ID
     * @param {string} pageToken - Sayfalama token (opsiyonel)
     */
    listSharedDrives: (channelId, pageToken) => {
        const params = {};
        if (pageToken) params.pageToken = pageToken;
        return request.get(`/google-drive/channels/${channelId}/shared-drives`, { params });
    },

    /**
     * Google Drive'da dosya arar
     * @param {string} channelId - Kanal ID
     * @param {string} query - Arama sorgusu
     * @param {string} pageToken - Sayfalama token (opsiyonel)
     * @param {string} driveId - Shared Drive ID (opsiyonel)
     */
    searchFiles: (channelId, query, pageToken, driveId) => {
        const params = { query };
        if (pageToken) params.pageToken = pageToken;
        if (driveId) params.driveId = driveId;
        return request.get(`/google-drive/channels/${channelId}/search`, { params });
    },

    /**
     * Dosya metadata'sını getirir
     * @param {string} channelId - Kanal ID
     * @param {string} fileId - Google Drive dosya ID
     */
    getFileMetadata: (channelId, fileId) => {
        return request.get(`/google-drive/channels/${channelId}/files/${fileId}`);
    },

    /**
     * Google Drive dosyasını indirir, S3'e yükler ve Asset oluşturur
     * @param {string} channelId - Kanal ID
     * @param {string} fileId - Google Drive dosya ID
     */
    downloadFile: (channelId, fileId) => {
        return request.post(`/google-drive/channels/${channelId}/download/${fileId}`);
    },

    /**
     * Asset'i Google Drive'a yükler
     * @param {string} channelId - Kanal ID
     * @param {string} folderId - Hedef klasör ID (opsiyonel)
     * @param {string} assetId - Asset ID
     */
    uploadFile: (channelId, folderId, assetId) => {
        return request.post(`/google-drive/channels/${channelId}/upload`, { folderId, assetId });
    },
};
